import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Input } from "../../../library/input";
import { Title } from "../../../library/title";
import PasswordStrengthBar from "react-password-strength-bar";

const Index = ({
  registrationObject,
  setRegistrationObject,
  clickRegister,
  validateGeneralLoading,
  termsChecked,
  setTermsChecked,
  setPasswordStrength,
}) => {
  return (
    <div className="register-container">
      <Title size="regular">Fyll inn detaljene</Title>
      <Row className="single-tab-row top">
        <Col className="single-tab-col">
          <div className="input-group">
            <label>
              Organisasjonsnummer{" "}
              <span className="label-question">
                <i
                  data-tip="Organisasjonsnummeret til foretaket ditt."
                  class="fad fa-question-circle"
                ></i>
              </span>
            </label>
            <Input
              format="organizationNumber"
              onChange={(e) =>
                setRegistrationObject({
                  ...registrationObject,
                  organizationNumber: e.target.value,
                })
              }
              value={registrationObject.organizationNumber}
              placeholder="123 456 789"
            />
          </div>
        </Col>
      </Row>
      <hr />
      <Row className="single-tab-row">
        <Col className="single-tab-col">
          <div className="input-group">
            <label>Fornavn</label>
            <Input
              onChange={(e) =>
                setRegistrationObject({
                  ...registrationObject,
                  firstName: e.target.value,
                })
              }
              value={registrationObject.firstName}
              placeholder="Gavin"
            />
          </div>
        </Col>
        <Col className="single-tab-col">
          <div className="input-group">
            <label>Etternavn</label>
            <Input
              onChange={(e) =>
                setRegistrationObject({
                  ...registrationObject,
                  lastName: e.target.value,
                })
              }
              value={registrationObject.lastName}
              placeholder="Belson"
            />
          </div>
        </Col>
      </Row>
      <Row className="single-tab-row">
        <Col className="single-tab-col">
          <div className="input-group">
            <label>E-post</label>
            <Input
              onChange={(e) =>
                setRegistrationObject({
                  ...registrationObject,
                  email: e.target.value,
                })
              }
              value={registrationObject.email}
              type="email"
              placeholder="gavin.belson@hooli.xyz"
            />
          </div>
        </Col>
        <Col className="single-tab-col">
          <div className="input-group">
            <label>Telefon</label>
            <Input
              format="phone"
              onChange={(e) =>
                setRegistrationObject({ ...registrationObject, mobile: e })
              }
              value={registrationObject.mobile}
              placeholder="123 45 678"
            />
          </div>
        </Col>
      </Row>
      <Row className="single-tab-row">
        <Col className="single-tab-col">
          <div className="input-group">
            <label>Passord</label>
            <Input
              type="password"
              onChange={(e) =>
                setRegistrationObject({
                  ...registrationObject,
                  password: e.target.value,
                })
              }
              value={registrationObject.password}
              placeholder="Passord"
              autocomplete="new-password"
            />
            <PasswordStrengthBar
              onChangeScore={(score) => setPasswordStrength(score)}
              className="strength-bar"
              barColors={["#ddd", "#F64E60", "#FFA800", "#3699FF", "#1BC5BD"]}
              minLength={8}
              password
              shortScoreWord="For svakt"
              scoreWords={[
                "For svakt",
                "Svakt",
                "Middels",
                "Sterkt",
                "Veldig sterkt",
              ]}
              password={
                registrationObject.password ? registrationObject.password : ""
              }
            />
          </div>
        </Col>
      </Row>
      <Row className="single-tab-row">
        <Col className="single-tab-col">
          <div className="information-container">
            <p className="description">
              Du vil automatisk få 14 dager gratis abonnement med Leadfind, og
              vil ikke behøve å betale noe før denne prøvetiden er utgått. For å
              ha mulighet til å gi flere andre brukere tilgang til ditt foretak
              kan du oppjustere antall i kassen.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="button-row">
        <Col className="terms-col">
          <div class="check-container">
            <input
              onClick={() => setTermsChecked(!termsChecked)}
              checked={termsChecked}
              type="checkbox"
              class="form-check-input"
              id="termsCheck"
            />
            <label class="form-check-label" for="termsCheck">
              Jeg godtar <Link to="/vilkår">brukervilkårene</Link>
            </label>
          </div>
        </Col>
        <Col className="button-col text-right">
          <button className="previous-button" type="button">
            <i class="fad fa-angle-left"></i> Forrige
          </button>
          <button
            className="next-button"
            type="button"
            onClick={() => clickRegister()}
          >
            {validateGeneralLoading ? "Validerer.." : "Neste"}{" "}
            {!validateGeneralLoading ? (
              <i class="fad fa-angle-right"></i>
            ) : (
              <i className="fas fa-circle-notch fa-spin"></i>
            )}
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
